import { checkIfPlaybackForAnonymousUsersEnabled } from '../features/checkIfAnonymousPlaybackEnabled';
import {checkIfShowPlayIconOnTileEnabled} from '../features/checkIfFreemiumFeatureEnabled';
import { checkIsUserAnonymous, getAnonymousAuthToken } from './bootstrap';

function checkIfAnonymousPlaybackPermitted(videoContent: any) {
    const isUserAnonymous = checkIsUserAnonymous();
    const isPlaybackForAnonymousEnabled =
        checkIfPlaybackForAnonymousUsersEnabled();
    const anonymousAuthToken = getAnonymousAuthToken();
    const hasNoEntitlementIds =
        videoContent &&
        videoContent?.entitlementIds &&
        videoContent?.entitlementIds.length === 0;
    const result =
        isUserAnonymous &&
        isPlaybackForAnonymousEnabled &&
        anonymousAuthToken &&
        hasNoEntitlementIds &&
        checkIfShowPlayIconOnTileEnabled();

    return result;
}

export { checkIfAnonymousPlaybackPermitted };
